<template>
  <div>
    <component :is="'style'">
      .footer-container{ background :
      {{ myTheme.customizeButton.backgroundColor }}; color :
      {{ myTheme.customizeButton.color }}
      }
    </component>
    <div class="container d-flex flex-column justify-content-center">
      <p class="font-weight-600 text-center mb-0 mt-3" v-if="showHeader">
        {{ $t("text.order_status") }}
      </p>
      <p class="text-center mb-3" v-if="showHeader">
        {{
          $t("text.last_update", {
            date_time: $moment(getLastStatus.last_update).format("HH:mm"),
          })
        }}
      </p>

      <div class="tracking-image"><el-image :src="getStatusImage" /></div>

      <p class="font-weight-600 text-center mb-0">
        {{
          deliveryFailed
            ? $t("text.delivery_of_order")
            : $t("text.your_order")
        }}
        <!--- show Delivery of order -->
      </p>
      <p class="font-weight-bolder order-id-font-size text-center mb-0">
        {{ order.id }}
      </p>
      <p
        class="font-weight-600 text-center mb-0"
        v-if="
          [
            ORDER_STATUS.ACCEPTED,
            ORDER_STATUS.COMPLETED,
            ORDER_STATUS.RECEIVED,
          ].includes(order.order_status)
        "
      >
        has been {{ getLastStatus.text }}
      </p>
      <p
        class="font-weight-600 text-center"
        v-if="order.order_status == ORDER_STATUS.RECEIVED"
      >
        by {{ order.location.name }}
      </p>
      <div
        v-if="
          [ORDER_TYPE.Delivery.id,ORDER_TYPE.Collection.id].includes(order.order_type)  &&
          [
            ORDER_STATUS.ACCEPTED,
            ORDER_STATUS.DELIVERY,
          ].includes(order.order_status)
        "
      >
        <div  v-if="deliveryFailed">
          <p class="font-weight-600 text-center mb-0">
            {{ $t("text.has_failed_due") }}
          </p>
          <p
            class="
              font-weight-600
              text-center
              reason_text
              mb-0
              text-danger text-xl
            "
          >
            {{ order.orderWhere2.pickup.reason_text }}
          </p>
          <p class="font-weight-bolder text-center mb-0 driver_note_title">
            {{ $t("text.driver_notes") }}
          </p>
          <p class="font-weight-600 text-center mb-0">
            {{
              order.orderWhere2.pickup.notes
                ? order.orderWhere2.pickup.notes
                : "N/A"
            }}
          </p>
        </div>
        <div v-else>
          <p class="font-weight-600 text-center mb-0">
            {{ order.order_type == ORDER_TYPE.Delivery.id ? $t("text.send_delivery_out") : $t("text.collection_ready_at") }}
          </p>
          <p class="font-weight-bolder order-id-font-size text-center mb-0">
            {{
              order.proposed_ready_time
                ? order.proposed_ready_time
                : "N/A"
            }}
          </p>
        </div>
      </div>

      <a
        class="text-decoration-none mt-2"
        :href="`tel:${order.location.telephone}`"
      >
        <div class="footer-container">
          <p class="font-weight-bold mb-0">{{ $t("text.any_problem") }}</p>
          <p class="mb-0">{{ $t("text.restaurant_number") }}</p>
          <p class="mb-0">{{ order.location.name }}</p>
          <p class="font-weight-bold mb-0">
            {{ order.location.telephone }}
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { ORDER_STATUS, ORDER_TYPE } from "@/utilities/enums";
import { getLastOrderStatus, getKeyByValue }from "@/utilities/helper";
export default {
  name: "order-status",
  props: {
    order: Object,
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getLastStatus() {
      return getLastOrderStatus(this.order.orderStatusHistory[0]);
    },
    getStatusImage() {
      if (this.order.order_status == ORDER_STATUS.COMPLETED)
        return "/img/tracking/COMPLETED.svg";
      if (this.order.order_status >= ORDER_STATUS.REJECTED)
        return "/img/tracking/REJECTED.svg";
      if ( this.order.where2_enabled && this.deliveryFailed) {
        return `/img/tracking/${this.order.orderWhere2.pickup.reason}.svg`;
      }

      return `/img/tracking/${getKeyByValue(
        ORDER_TYPE,
        this.order.order_type,
        true
      )}_${getKeyByValue(
        ORDER_STATUS,
        this.order.order_status
      )}.svg`;
    },
    deliveryFailed() {
      return (
        this.order.orderWhere2 && this.order.orderWhere2.drop.status == 4
      );
    },
  },
  data(){
    return {
      ORDER_STATUS,
      ORDER_TYPE
    }
  }
};
</script>